import React, { useEffect, useState, useRef } from "react";
import arrow from "../assets/arrow.png";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { url, ak } from "../pages/HomePage";

const EMPTY_ARRAY = [];

const options = [
  { label: "Kotisairaanhoito", value: 1 },
  { label: "Kotihoito", value: 2 },
  { label: "Henkilökohtainen avustus", value: 3 },
  { label: "Lastenhoito", value: 4 },
  /* { label: "Avustaminen", value: 6 }, */
];

const languages = [
  { label: "Abhaasi", value: "ab" },
  { label: "Afar", value: "aa" },
  { label: "Afrikaans", value: "af" },
  { label: "Akan", value: "ak" },
  { label: "Albania", value: "sq" },
  { label: "Amhara", value: "am" },
  { label: "Arabia", value: "ar" },
  { label: "Aragonialainen", value: "an" },
  { label: "Armenia", value: "hy" },
  { label: "Assami", value: "as" },
  { label: "Avaari", value: "av" },
  { label: "Avestan", value: "ae" },
  { label: "Aymara", value: "ay" },
  { label: "Azerbaidžan", value: "az" },
  { label: "Bambara", value: "bm" },
  { label: "Baškiiri", value: "ba" },
  { label: "Baski", value: "eu" },
  { label: "Valko-Venäjä", value: "be" },
  { label: "Bengali", value: "bn" },
  { label: "Bislama", value: "bi" },
  { label: "Bosnia", value: "bs" },
  { label: "Bretoni", value: "br" },
  { label: "Bulgaria", value: "bg" },
  { label: "Burma", value: "my" },
  { label: "Katalaani, Valencialainen", value: "ca" },
  { label: "Chamorro", value: "ch" },
  { label: "Tšetšeeni", value: "ce" },
  { label: "Chewa", value: "ny" },
  { label: "Kiina", value: "zh" },
  { label: "Tšuvassi", value: "cv" },
  { label: "Cornish", value: "kw" },
  { label: "Korsika", value: "co" },
  { label: "Cree", value: "cr" },
  { label: "Kroatia", value: "hr" },
  { label: "Tšekki", value: "cs" },
  { label: "Tanska", value: "da" },
  { label: "Malediivit", value: "dv" },
  { label: "Hollanti", value: "nl" },
  { label: "Dzongkha", value: "dz" },
  { label: "Englanti", value: "en" },
  { label: "Esperanto", value: "eo" },
  { label: "Viro", value: "et" },
  { label: "Ewe", value: "ee" },
  { label: "Färsaaret", value: "fo" },
  { label: "Fidži", value: "fj" },
  { label: "Suomi", value: "fi" },
  { label: "Ranska", value: "fr" },
  { label: "Länsi-Friisi", value: "fy" },
  { label: "Fulani", value: "ff" },
  { label: "Skotlannin gaeli", value: "gd" },
  { label: "Galicia", value: "gl" },
  { label: "Ganda", value: "lg" },
  { label: "Georgia", value: "ka" },
  { label: "Saksa", value: "de" },
  { label: "Kreikka", value: "el" },
  { label: "Kalaallisut, Grönlanti", value: "kl" },
  { label: "Guarani", value: "gn" },
  { label: "Gujarati", value: "gu" },
  { label: "Haitin", value: "ht" },
  { label: "Hausa", value: "ha" },
  { label: "Hebrea", value: "he" },
  { label: "Herero", value: "hz" },
  { label: "Hindi", value: "hi" },
  { label: "Hiri Motu", value: "ho" },
  { label: "Unkari", value: "hu" },
  { label: "Islanti", value: "is" },
  { label: "Ido", value: "io" },
  { label: "Igbo", value: "ig" },
  { label: "Indonesia", value: "id" },
  { label: "Interlingua", value: "ia" },
  { label: "Interlingue", value: "ie" },
  { label: "Inuktitut", value: "iu" },
  { label: "Inupiaq", value: "ik" },
  { label: "Iiri", value: "ga" },
  { label: "Italia", value: "it" },
  { label: "Japani", value: "ja" },
  { label: "Jaavalainen", value: "jv" },
  { label: "Kannada", value: "kn" },
  { label: "Kanuri", value: "kr" },
  { label: "Kashmiri", value: "ks" },
  { label: "Kazakki", value: "kk" },
  { label: "Keski-Khmer", value: "km" },
  { label: "Kikuyu", value: "ki" },
  { label: "Kinyarwanda", value: "rw" },
  { label: "Kirgiisi", value: "ky" },
  { label: "Komi", value: "kv" },
  { label: "Kongo", value: "kg" },
  { label: "Korea", value: "ko" },
  { label: "Kuanyama, Kwanyama", value: "kj" },
  { label: "Kurdi", value: "ku" },
  { label: "Laos", value: "lo" },
  { label: "Latina", value: "la" },
  { label: "Latvia", value: "lv" },
  { label: "Limburgilainen", value: "li" },
  { label: "Lingala", value: "ln" },
  { label: "Liettua", value: "lt" },
  { label: "Luba-Katanga", value: "lu" },
  { label: "Luxemburg", value: "lb" },
  { label: "Makedonia", value: "mk" },
  { label: "Madagaskar", value: "mg" },
  { label: "Malaiji", value: "ms" },
  { label: "Malajalam", value: "ml" },
  { label: "Malta", value: "mt" },
  { label: "Manx", value: "gv" },
  { label: "Maori", value: "mi" },
  { label: "Marathi", value: "mr" },
  { label: "Marshallese", value: "mh" },
  { label: "Mongolia", value: "mn" },
  { label: "Nauru", value: "na" },
  { label: "Navajo", value: "nv" },
  { label: "Pohjois-Ndebele", value: "nd" },
  { label: "Etelä-Ndebele", value: "nr" },
  { label: "Ndonga", value: "ng" },
  { label: "Nepali", value: "ne" },
  { label: "Norja", value: "no" },
  { label: "Norjan Bokmål", value: "nb" },
  { label: "Norjan Nynorsk", value: "nn" },
  { label: "Nuosu", value: "ii" },
  { label: "Okcitan", value: "oc" },
  { label: "Ojibwa", value: "oj" },
  { label: "Oriya", value: "or" },
  { label: "Oromo", value: "om" },
  { label: "Osseetti", value: "os" },
  { label: "Pali", value: "pi" },
  { label: "Pashto", value: "ps" },
  { label: "Persia", value: "fa" },
  { label: "Puola", value: "pl" },
  { label: "Portugali", value: "pt" },
  { label: "Punjabi", value: "pa" },
  { label: "Quechua", value: "qu" },
  { label: "Romania", value: "ro" },
  { label: "Romania", value: "ro" },
  { label: "Retoromaani", value: "rm" },
  { label: "Ruanda", value: "rn" },
  { label: "Venäjä", value: "ru" },
  { label: "Pohjoissaame", value: "se" },
  { label: "Samoa", value: "sm" },
  { label: "Sango", value: "sg" },
  { label: "Sanskrit", value: "sa" },
  { label: "Sardi", value: "sc" },
  { label: "Serbia", value: "sr" },
  { label: "Shona", value: "sn" },
  { label: "Sindhi", value: "sd" },
  { label: "Sinhala", value: "si" },
  { label: "Slovakia", value: "sk" },
  { label: "Slovenia", value: "sl" },
  { label: "Somalia", value: "so" },
  { label: "Eteläsotho", value: "st" },
  { label: "Espanja", value: "es" },
  { label: "Sunda", value: "su" },
  { label: "Swahili", value: "sw" },
  { label: "Swazi", value: "ss" },
  { label: "Ruotsi", value: "sv" },
  { label: "Tagalog", value: "tl" },
  { label: "Tahiti", value: "ty" },
  { label: "Tadžikki", value: "tg" },
  { label: "Tamili", value: "ta" },
  { label: "Tataari", value: "tt" },
  { label: "Telugu", value: "te" },
  { label: "Thai", value: "th" },
  { label: "Tiibet", value: "bo" },
  { label: "Tigrinja", value: "ti" },
  { label: "Tonga (Tonga-saaret)", value: "to" },
  { label: "Tsonga", value: "ts" },
  { label: "Tswana", value: "tn" },
  { label: "Turkki", value: "tr" },
  { label: "Turkmeeni", value: "tk" },
  { label: "Twi", value: "tw" },
  { label: "Uiguuri", value: "ug" },
  { label: "Ukraina", value: "uk" },
  { label: "Urdu", value: "ur" },
  { label: "Uzbekki", value: "uz" },
  { label: "Venda", value: "ve" },
  { label: "Vietnam", value: "vi" },
  { label: "Volapük", value: "vo" },
  { label: "Valloni", value: "wa" },
  { label: "Wales", value: "cy" },
  { label: "Wolof", value: "wo" },
  { label: "Xhosa", value: "xh" },
  { label: "Jiddiš", value: "yi" },
  { label: "Joruba", value: "yo" },
  { label: "Zhuang, Chuang", value: "za" },
  { label: "Zulu", value: "zu" },
  { label: "Viittomakieli", value: "sign"},
];

function EditUser() {
  const location = useLocation();
  const state = location.state || {};
  const categoryValues = Array.isArray(state.categories) ? state.categories : EMPTY_ARRAY;
  const languageValues = Array.isArray(state.languages) ? state.languages : EMPTY_ARRAY;
  console.log(state);
  const [selected, setSelected] = useState([...categoryValues]);
  const [selected2, setSelected2] = useState([...languageValues]);
  const [crVerification, setCrVerification] = useState({
    checked: Boolean(state.cr_checked),
    date: state.cr_check_date || "",
    checker: state.cr_checker || "",
  });
  const [cities, setCities] = useState(
    (Array.isArray(state.cities) ? state.cities : String(state.cities || "").split(","))
      .map((city) => String(city).trim())
      .filter(Boolean)
      .slice(0, 5)
  );
  const [municipalityOptions, setMunicipalityOptions] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);

  const usernameInputRef = useRef();
  const firstNameInputRef = useRef();
  const lastNameInputRef = useRef();
  const emailInputRef = useRef();
  const phoneInputRef = useRef();
  const genderInputRef = useRef();
  /* const passwordInputRef = useRef(); */
  const postNumberInputRef = useRef();
  const addressInputRef = useRef();
  const drivingLicenseInputRef = useRef();
  const carInputRef = useRef();
  /* const categoriesInputRef = useRef(); */
  /* const languagesInputRef = useRef(); */
  const onlyNecassaryMsgsInputRef = useRef();
  function submitHandler(event) {
    event.preventDefault();

    const userData = {
      username: usernameInputRef.current.value,
      first_name: firstNameInputRef.current.value.trim(),
      last_name: lastNameInputRef.current.value.trim(),
      gender: genderInputRef.current.value,
      email: emailInputRef.current.value,
      phone: phoneInputRef.current.value,
      privilege: state.privilege,
      /* password: passwordInputRef.current.value, */
      postNumber: postNumberInputRef.current.value,
      address: addressInputRef.current.value,
      cities: cities,
      driving_license: drivingLicenseInputRef.current.value === "true",
      car: carInputRef.current.value === "true",
      /* categories: categoriesInputRef.current.value, */
      /* languages: languagesInputRef.current.value + "", */
      only_necessary_msgs: onlyNecassaryMsgsInputRef.current.value === "true",
    };
    var tmpSelected = [];
    var tmpSelected2 = [];
    for (var i = 0; i < selected.length; i++) {
      tmpSelected.push(selected[i].value);
    }
    for (var v = 0; v < selected2.length; v++) {
      tmpSelected2.push(selected2[v].value);
    }
    var body = JSON.stringify({
      username: userData.username,
      fullname: `${userData.first_name} ${userData.last_name}`.trim(),
      first_name: userData.first_name,
      last_name: userData.last_name,
      gender: userData.gender,
      email: userData.email,
      phone: userData.phone,
      privilege: userData.privilege,
      password: userData.password,
      postnumber: userData.postNumber,
      address: userData.address,
      cities: userData.cities,
      driving_license: userData.driving_license,
      car: userData.car,
      categories: tmpSelected,
      languages: tmpSelected2,
      only_necessary_msgs: userData.only_necessary_msgs,
    });

    fetch(url + `/admin/user/edit/${state.id}` + ak, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Käyttäjän tietojen tallennus epäonnistui");
        }

        const criminalRecordBody = {
          checked: crVerification.checked,
          checked_at: crVerification.checked ? crVerification.date : "",
          checker: crVerification.checked ? crVerification.checker : "",
        };

        return fetch(
          url + `/admin/user/${state.id}/criminal-record/verify` + ak,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(criminalRecordBody),
          }
        );
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Rikosrekisteritietojen tallennus epäonnistui");
        }

        window.location.href = "/tyontekijat";
      })
      .catch((error) => {
        console.error("Tallennus epäonnistui:", error);
        window.alert("Muutosten tallennus epäonnistui.");
      });
  }

  useEffect(() => {
    var tmpCategories = [];

    categoryValues.map((i) => {
      if (i === 1) {
        tmpCategories.push(options[0]);
      } else if (i === 2) {
        tmpCategories.push(options[1]);
      } else if (i === 3) {
        tmpCategories.push(options[2]);
      } else if (i === 4) {
        tmpCategories.push(options[3]);
      } else {
        tmpCategories.push(options[4]);
      }
      return null;
    });
    console.log("Tässä miltä näyttää categoriat: " + tmpCategories.toString());
    setSelected(tmpCategories);

    var tmpLanguages = [];

    languageValues.map((languageValue) => {
      const foundLanguage = languages.find(lang => lang.value === languageValue);
      if (foundLanguage) {
        tmpLanguages.push(foundLanguage);
      }
      return null;
    });
    setSelected2(tmpLanguages);

    fetch(url + "/admin/municipalities" + ak, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Kuntaluettelon lataus epäonnistui");
        }
        return response.json();
      })
      .then((data) => {
        setMunicipalityOptions(
          data.map((municipality) => ({
            label: municipality.name,
            value: municipality.name,
          }))
        );
      })
      .catch((error) => {
        console.error("Kuntaluettelon lataus epäonnistui:", error);
      });

    let pictureUrl = null;

    fetch(url + `/admin/user/${state.id}/picture` + ak + `&_t=${Date.now()}`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        }
        if (!response.ok) {
          throw new Error("Profiilikuvan lataus epäonnistui");
        }
        return response.blob();
      })
      .then((blob) => {
        if (!blob) {
          setProfilePicture(null);
          return;
        }

        pictureUrl = URL.createObjectURL(blob);
        setProfilePicture(pictureUrl);
      })
      .catch((error) => {
        console.error("Profiilikuvan lataus epäonnistui:", error);
        setProfilePicture(null);
      });

    return () => {
      if (pictureUrl) {
        URL.revokeObjectURL(pictureUrl);
      }
    };
  }, [categoryValues, languageValues, state.id]);

  return (
    <div className="pt-[8%] px-20 relative">
      <img
        src={arrow}
        alt="takaisin"
        className="absolute h-6 px-8 mb-4 cursor-pointer top-16 left-10"
        onClick={() => window.history.back()}
      ></img>
      <form className="m-0 card">
        <div className="flex flex-col items-center mb-8">
          {profilePicture ? (
            <img
              src={profilePicture}
              alt="Työntekijän profiilikuva"
              className="object-cover w-32 h-32 border border-gray-200 rounded-full shadow-sm"
            />
          ) : (
            <div className="flex items-center justify-center w-32 h-32 text-sm text-center text-gray-400 border border-gray-200 rounded-full">
              Ei profiilikuvaa
            </div>
          )}
          <div className="mt-3 text-lg font-bold">
            {`${state.first_name || ''} ${state.last_name || ''}`.trim() || state.fullname}
          </div>
        </div>

        <div className="grid justify-center w-full grid-cols-3 gap-6 px-8">
          <div className="flex flex-col w-full ">
            <label className="font-bold text-gray-500">Käyttäjänimi</label>
            <input
              class="inputStyle px-2 text-gray-500"
              type="text"
              defaultValue={state.username}
              ref={usernameInputRef}
              disabled
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold">Etunimi</label>
            <input
              class="inputStyle px-2 "
              type="text"
              defaultValue={state.first_name || ""}
              ref={firstNameInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold">Sukunimi</label>
            <input
              class="inputStyle px-2 "
              type="text"
              defaultValue={state.last_name || ""}
              ref={lastNameInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold text-gray-500">Työntekijänumero</label>
            <input
              class="inputStyle px-2 text-gray-500"
              type="text"
              value={state.employee_number || ""}
              disabled
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Sukupuoli</label>
            <input
              class="inputStyle px-2"
              type="text"
              defaultValue={state.gender}
              ref={genderInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Sähköposti</label>
            <input
              class="inputStyle px-2"
              type="text"
              defaultValue={state.email}
              ref={emailInputRef}
            />
          </div>
          {/* <div className="flex flex-col">
            <label className="font-bold ">Salasana</label>
            <input
              class="inputStyle px-2"
              type="text"
              name="name"
              defaultValue={state.password}
              ref={passwordInputRef}
            />
          </div> */}
          <div className="flex flex-col">
            <label className="font-bold ">Puhelin</label>
            <input
              class="inputStyle px-2"
              type="text"
              defaultValue={state.phone}
              ref={phoneInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Postinumero</label>
            <input
              class="inputStyle px-2"
              type="text"
              defaultValue={state.postnumber}
              ref={postNumberInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Osoite</label>
            <input
              class="inputStyle px-2"
              type="text"
              defaultValue={state.address || ""}
              ref={addressInputRef}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold">
              Työskentelykunnat ({cities.length}/5)
            </label>
            <MultiSelect
              options={municipalityOptions}
              value={cities.map((city) => ({
                label: city,
                value: city,
              }))}
              onChange={(selectedMunicipalities) => {
                if (selectedMunicipalities.length <= 5) {
                  setCities(
                    selectedMunicipalities.map(
                      (municipality) => municipality.value
                    )
                  );
                }
              }}
              labelledBy="Valitse työskentelykunnat"
              hasSelectAll={false}
              overrideStrings={{
                selectSomeItems: "Valitse työskentelykunnat...",
                allItemsAreSelected: "Kaikki kunnat valittu",
                search: "Hae kuntaa...",
                clearSearch: "Tyhjennä haku",
              }}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Ajokortti</label>
            <select
              className="h-full px-2 inputStyle"
              type="number"
              autoComplete="off"
              defaultValue={state.drivingLicence}
              ref={drivingLicenseInputRef}
            >
              <option value={true}>Kyllä</option>
              <option value={false}>Ei</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label className="font-bold ">Auto</label>
            <select
              className="h-full px-2 inputStyle"
              type="number"
              autoComplete="off"
              defaultValue={state.car}
              ref={carInputRef}
            >
              <option value={true}>Kyllä</option>
              <option value={false}>Ei</option>
            </select>
          </div>
          <div>
            <label className="font-bold ">Kategoriat</label>
            <MultiSelect
              options={options}
              value={selected}
              onChange={setSelected}
              labelledBy="Select"
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold ">Kielet</label>
            <MultiSelect
              options={languages}
              value={selected2}
              onChange={setSelected2}
              labelledBy="Select"
            />
          </div>
          <div className="flex flex-col">
            <label className="font-bold">Rikosrekisteri tarkistettu</label>
            <select
              className="px-2 inputStyle"
              value={crVerification.checked ? "true" : "false"}
              onChange={(event) => {
                const checked = event.target.value === "true";
                setCrVerification((current) => ({
                  ...current,
                  checked,
                  date: checked ? current.date : "",
                  checker: checked ? current.checker : "",
                }));
              }}
            >
              <option value="false">Ei</option>
              <option value="true">Kyllä</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label className="font-bold">Tarkistuksen ajankohta</label>
            <input
              className="px-2 inputStyle"
              type="date"
              disabled={!crVerification.checked}
              value={
                crVerification.checked && crVerification.date
                  ? moment(crVerification.date).format("YYYY-MM-DD")
                  : ""
              }
              onChange={(event) =>
                setCrVerification((current) => ({
                  ...current,
                  date: event.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col">
            <label className="font-bold">Tarkistaja</label>
            <input
              className="px-2 inputStyle"
              type="text"
              disabled={!crVerification.checked}
              value={crVerification.checked ? crVerification.checker : ""}
              onChange={(event) =>
                setCrVerification((current) => ({
                  ...current,
                  checker: event.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col">
            <label className="font-bold ">Vain tarpeelliset ilmoitukset</label>
            <select
              className="px-2 inputStyle"
              type="number"
              autoComplete="off"
              value={state.onlyNecassaryMsgs}
              ref={onlyNecassaryMsgsInputRef}
            >
              <option value={true}>Kyllä</option>
              <option value={false}>Ei</option>
            </select>
          </div>
          <div className="flex items-center justify-start w-full">
            <button
              className="h-12 text-lg font-bold text-white rounded bg-main w-44 drop-shadow-md"
              onClick={(event) => submitHandler(event)}
            >
              Tallenna muutokset
            </button>
          </div>
          <div></div>
        </div>
      </form>
    </div>
  );
}

export default EditUser;
